import { render } from "./UploadRenavam.vue?vue&type=template&id=f7b52bc4"
import script from "./UploadRenavam.vue?vue&type=script&lang=js"
export * from "./UploadRenavam.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__